import styled from 'styled-components';

interface HelpPanelContentProps {
  isVisible: boolean;
}

export const HelpPanelContainer = styled.div`
  position: fixed;
  bottom: 2.5rem;
  right: 1rem;
  display: flex;
  z-index: 1001;

  > svg {
    color: ${({ theme }: {theme: any}) => theme.themePrimary};
    cursor: pointer;
    z-index: 1;
  }
`;

export const HelpPanelContent = styled.div<HelpPanelContentProps>`
  width: 300px;
  border-radius: 16px;

  padding: ${({ isVisible }) => (isVisible ? '32px 16px' : '0')};
  max-height: ${({ isVisible }) => (isVisible ? '100%' : '0')};
  max-width: ${({ isVisible }) => (isVisible ? '100%' : '0')};
  overflow: hidden;

  position: fixed;
  bottom: 3.5rem;
  right: 32px;

  display: flex;
  flex-direction: column;

  background: ${({ theme }: {theme: any}) => theme.neutralLighter};
  box-shadow: inset 0 6px 0 0 #fd6262, 1px 1px 16px rgba(0, 0, 0, 0.3);

  transition: all 0.3s ease-in-out;

  .helpPanelMenu {
    opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
    transition: all 0.3s 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    ul.tutorials {
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      li {
        display: flex;
        flex-direction: column;

        button {
          display: flex;
          font: 400 0.9rem/0.9rem 'Segoe UI', sans-serif;
          align-items: center;
          text-align: left;
          gap: 6px;
          width: 100%;
          padding: 0.5rem 1rem;
          border-radius: 1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          background: ${({ theme }: {theme: any}) => theme.neutralLight};
          border: none;

          &:hover {
            background: ${({ theme }: {theme: any}) => theme.themePrimary};
            color: #fff;
          }
        }
      }
    }

    .faq {
      padding-left: 0.5rem;

      .itemContent {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        p.itemDescription {
          font: 400 0.8rem/0.9rem 'Segoe UI', sans-serif;
        }

        .videoContainer {
          position: relative;
          width: 100%;
          padding-bottom: 56.25%;
          overflow: hidden;
          border-radius: 1rem;

          iframe {
            display: flex;
            border: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        }

        iframe {
          border: none;

          ::-webkit-scrollbar {
            width: 20px;
          }

          ::-webkit-scrollbar-track {
            background-color: transparent;
          }

          ::-webkit-scrollbar-thumb {
            background-color: #d6dee1;
            border-radius: 20px;
            border: 6px solid transparent;
            background-clip: content-box;
          }

          ::-webkit-scrollbar-thumb:hover {
            background-color: #a8bbbf;
          }
        }
      }
    }

    .feedback {
      display: flex;
      flex-direction: column;
      gap: 16px;

      select {
        padding: 0.25rem 0.5rem;
        border-radius: 6px;
        font: 300 0.8rem/1.1rem 'Roboto', sans-serif;
        background: ${({ theme }: {theme: any}) => theme.neutralLighter};
        color: ${({ theme }: {theme: any}) => theme.black};

        &:focus {
          border: 1px solid ${({ theme }: {theme: any}) => theme.themePrimary};
        }
      }

      form {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;

        textarea {
          background: ${({ theme }: {theme: any}) => theme.neutralLighter};
          color: ${({ theme }: {theme: any}) => theme.black};
          width: 100%;
          border: 3px dotted ${({ theme }: {theme: any}) => theme.neutralQuaternary};
          border-radius: 12px;
          padding: 0.5rem;
        }

        .feedbackFooter {
          display: flex;
          gap: 0.5rem;

          button {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 10px 1.2rem;
            border-radius: 6px;
            border: none;
            background: ${({ theme }: {theme: any}) => theme.themePrimary};
            color: #fff;

            font: 500 1rem/1rem 'Roboto', sans-serif;
            cursor: pointer;

            transition: all 0.2s ease;

            &:hover {
              background: ${({ theme }: {theme: any}) => theme.themeTertiary};
            }
          }

          span.statusMessage {
            display: flex;
            align-items: center;
            font: 400 0.8rem/1.1rem 'Segoe UI', sans-serif;
            gap: 0.2rem;

            svg {
              height: 70%;
              width: auto;
            }

            &#messagesent {
              color: #5cb85c;
            }

            &#messagefailed {
              color: #fc100d;
            }
          }
        }
      }
    }
  }
`;
